/**
 * Canonical carrier-contract-rate enums. Values match the Postgres enum types
 * on `carrier_contract_rates` — changing case requires a migration + backfill.
 */

export enum ContractRateStatus {
  DRAFT = 'DRAFT',
  ACTIVE = 'ACTIVE',
  EXPIRED = 'EXPIRED',
  SUSPENDED = 'SUSPENDED',
}

export const CONTRACT_RATE_STATUS_LABELS: Record<ContractRateStatus, string> = {
  [ContractRateStatus.DRAFT]: 'Draft',
  [ContractRateStatus.ACTIVE]: 'Active',
  [ContractRateStatus.EXPIRED]: 'Expired',
  [ContractRateStatus.SUSPENDED]: 'Suspended',
};

export const CONTRACT_RATE_STATUS_COLORS: Record<ContractRateStatus, string> = {
  [ContractRateStatus.DRAFT]: 'gray',
  [ContractRateStatus.ACTIVE]: 'green',
  [ContractRateStatus.EXPIRED]: 'red',
  [ContractRateStatus.SUSPENDED]: 'orange',
};

export enum LaneMatchType {
  ZIP_EXACT = 'ZIP_EXACT',
  ZIP_PREFIX = 'ZIP_PREFIX',
  METRO = 'METRO',
  STATE = 'STATE',
  REGION = 'REGION',
}

export const LANE_MATCH_TYPE_LABELS: Record<LaneMatchType, string> = {
  [LaneMatchType.ZIP_EXACT]: 'ZIP Code (Exact)',
  [LaneMatchType.ZIP_PREFIX]: 'ZIP Prefix',
  [LaneMatchType.METRO]: 'Metro Area',
  [LaneMatchType.STATE]: 'State',
  [LaneMatchType.REGION]: 'Region',
};

export enum RateStructure {
  PER_MILE = 'PER_MILE',
  PER_CWT = 'PER_CWT',
  FLAT_RATE = 'FLAT_RATE',
  PER_PALLET = 'PER_PALLET',
}

export const RATE_STRUCTURE_LABELS: Record<RateStructure, string> = {
  [RateStructure.PER_MILE]: 'Per Mile',
  [RateStructure.PER_CWT]: 'Per CWT',
  [RateStructure.FLAT_RATE]: 'Flat Rate',
  [RateStructure.PER_PALLET]: 'Per Pallet',
};

export enum FuelSurchargeType {
  NONE = 'NONE',
  FIXED_PERCENTAGE = 'FIXED_PERCENTAGE',
  DOE_INDEXED = 'DOE_INDEXED',
  INCLUDED = 'INCLUDED',
}

export const FUEL_SURCHARGE_TYPE_LABELS: Record<FuelSurchargeType, string> = {
  [FuelSurchargeType.NONE]: 'None',
  [FuelSurchargeType.FIXED_PERCENTAGE]: 'Fixed %',
  [FuelSurchargeType.DOE_INDEXED]: 'DOE Indexed',
  [FuelSurchargeType.INCLUDED]: 'Included',
};

export enum VolumeCommitmentType {
  NONE = 'NONE',
  ANNUAL = 'ANNUAL',
  MONTHLY = 'MONTHLY',
  QUARTERLY = 'QUARTERLY',
}

export const VOLUME_COMMITMENT_TYPE_LABELS: Record<VolumeCommitmentType, string> = {
  [VolumeCommitmentType.NONE]: 'None',
  [VolumeCommitmentType.ANNUAL]: 'Annual',
  [VolumeCommitmentType.MONTHLY]: 'Monthly',
  [VolumeCommitmentType.QUARTERLY]: 'Quarterly',
};
